/**
 * Sections of a collector's public profile. Selling and In collection are both item listings (one
 * elastic request each via the `sellable` flag, see useProfileItemSearch); Wantlists, Achievements,
 * Bio and Master sets are standalone panels.
 */
export enum CollectorProfileTab {
  Selling = "selling",
  InCollection = "in-collection",
  Wantlists = "wantlists",
  Achievements = "achievements",
  Bio = "bio",
  MasterSets = "master-sets",
}

/** FE-only filter path key — not one of the API's dynamic facet parameters. */
export const COLLECTOR_PROFILE_TAB_FILTER_SLUG = "tab";
